import { render, staticRenderFns } from "./FocusLock.vue?vue&type=template&id=15b035fd"
import script from "./FocusLock.vue?vue&type=script&lang=js"
export * from "./FocusLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports